import StoryblokClient from 'storyblok-js-client'
import processEnvPublic from 'unlikely-env/public'

export default new StoryblokClient({
  accessToken: processEnvPublic('NEXT_PUBLIC_STORYBLOK_TOKEN'),
  cache: {
    clear: 'auto',
    type: 'memory',
  },
})

class PageSbParams {
  static instance: PageSbParams;

  [key: string]: any
}

export const pageSbParams = new PageSbParams()
